import app from './app'

export default {
    url: (profileId: string) => app({ authorized: 'disable' }).getUri({ url: `/profiles/${profileId}/vcard` }),
}